export default "__VITE_ASSET__DbmpDgQY__"